<template>
  <div v-if="initialDataLoading" class="text-center">
     <Loader></Loader>
     <h6 class="align-content-center align-content-center"> {{ loadingText }}</h6>
  </div>
  <div v-else class="app" style="background-color: #fbfbfb">
    <BaseHeader />
    <div class="app-body">
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Loader from '@/expertoRetail/atoms/ExpertoRetailLoader'
import BaseHeader from '@/app/nav_bar/BaseHeader'
import webSocketService from '@/services/WebSocketService'

export default {
  name: 'full',
  components: {
    Loader,
    BaseHeader
  },
  data () {
    return {
      initialDataLoading: true
    }
  },
  computed: {
    configLoaded () {
      return this.$store.getters.isConfigLoaded
    },
    loadingText () {
      return !this.configLoaded ? 'Cargando Configuraciones' : 'Cargando status de venta'
    },
    userInfo () {
      return this.$store.getters.userInfo || {}
    }
  },
  async mounted () {
    this.getAvailableSize()
    await this.$store.dispatch('fetchDesktopParameterConfig')
    
    // Connect to WebSocket after config is loaded and userInfo is available
    if (this.userInfo && this.userInfo.id) {
      webSocketService.connect(this.userInfo.id)
    }
    
    this.initialDataLoading = false
  },
  beforeDestroy () {
    this.$eventHub.$off('dashboard-is-ready')
  },
  methods: {
    getAvailableSize () {
      let viewPort = window.innerHeight
      let headerHeight = 41
      this.$store.commit('commit_appAvailableHeight', viewPort - headerHeight)
    }
  }
}
</script>

<style scoped>
.container-fluid {
  padding-left: 2px;
  padding-right: 2px;
}

.outer {
  width:100%;
}

.center {
  margin: auto;
  width: 100%;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/containers/Full.vue